import { render, staticRenderFns } from "./UserDetailContainer.vue?vue&type=template&id=701b2568&scoped=true&"
import script from "./UserDetailContainer.vue?vue&type=script&lang=js&"
export * from "./UserDetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserDetailContainer.vue?vue&type=style&index=1&id=701b2568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701b2568",
  null
  
)

export default component.exports